module.exports = __webpack_public_path__ + "static/img/a1.782a281.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate/attestation/a1.png
// module id = eobG
// module chunks = 0